/**
 * Mutation used to transition RFX Request.
 */

import { gql } from '@apollo/client';

export const transitionRFXRequestMutation = gql`
  mutation transitionRFXRequest(
    $rfxRequestRevisionedId: RFXRevisionedIdInput!
    $toStateName: String!
    $reason: String
  ) {
    transitionRFXRequest(
      rfxRequestRevisionedId: $rfxRequestRevisionedId
      toStateName: $toStateName
      reason: $reason
    )
  }
`;